import { Box, Chip, CircularProgress, Typography } from '@mui/material';
import { ReorderableBlockList } from '../../CommonComponents/ReorderableBlockList';
import { IStory } from '@opengov/stories-shared/types';

import * as _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { IStoryListing, IStoryListMessages } from '../../../../types';
import { getStoryStatusChipParams } from '../../../common/utils';

import { styles } from './StoryListTable.styles';

export interface IStoryListTableProps {
  isOrganizePublicationStories?: boolean;
  isLoading: boolean;
  messages: IStoryListMessages;
  storyListContents: IStoryListing;
  isOrganizeStoriesInProgress: boolean;
  setIsOrganizeStoriesInProgress?(value: boolean): void;
  setOrganizedStoriesList?(storyList: IStory[]): void;
}

export const StoryListTable: React.FC<IStoryListTableProps> = ({
  storyListContents,
  isOrganizeStoriesInProgress,
  isLoading,
  isOrganizePublicationStories,
  setIsOrganizeStoriesInProgress,
  setOrganizedStoriesList
}) => {
  const [storiesList, setStoriesList] = useState(storyListContents?.data || []);
  useEffect(() => {
    if (!isOrganizeStoriesInProgress) setStoriesList(storyListContents?.data);
  }, [isOrganizeStoriesInProgress, storyListContents?.data]);

  const getRows = (storiesListArray) => {
    return storiesListArray?.map((story: IStory) => {
      const formatedCreatedAtDate = moment.utc(story.createdAt).fromNow() as string;
      const chipParams = getStoryStatusChipParams(story);
      return (
        <ReorderableBlockList.Item
          dataTest="reorderable-folders-list-item"
          key={story._id}
          id={story._id}
          label={story.title}
        >
          <Box sx={styles.listItem}>
            <Typography variant="body2" data-test="story-title" sx={styles.organizeStoriesDefaultText}>
              {story.title}
            </Typography>
            <Box sx={styles.organizeStoriesText}>
              {!!chipParams && (
                <Chip label={chipParams.text} variant={chipParams.variant} color={chipParams.color} size="small" />
              )}
            </Box>
            <Typography variant="body2" sx={styles.organizeStoriesDefaultText}>
              {formatedCreatedAtDate}
            </Typography>
          </Box>
        </ReorderableBlockList.Item>
      );
    });
  };

  const onStoriesDragEnd = (sourceIndex: number, destinationIndex: number) => {
    const updatedStoriesList = _.cloneDeep(storiesList) as IStory[];
    const reorderedStory = updatedStoriesList.splice(sourceIndex, 1)[0];
    updatedStoriesList.splice(destinationIndex, 0, reorderedStory);
    setStoriesList(updatedStoriesList);
    setIsOrganizeStoriesInProgress?.(true);
    setOrganizedStoriesList?.(updatedStoriesList);
  };

  if (isLoading) {
    // Loading state
    return (
      <Box sx={styles.centered} data-test="story-list-loading-spinner">
        <CircularProgress aria-label="Loading stories" />
      </Box>
    );
  }
  return Array.isArray(storiesList) && storiesList.length > 0 ? (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Typography variant="body2" color="text.secondary" fontWeight="medium" sx={styles.organizeStoriesText}>
          Name
        </Typography>
        <Typography variant="body2" color="text.secondary" fontWeight="medium" sx={styles.organizeStoriesText}>
          Status
        </Typography>
        <Typography variant="body2" color="text.secondary" fontWeight="medium" sx={styles.organizeStoriesText}>
          Created On
        </Typography>
      </Box>
      <ReorderableBlockList dataTest="reorderable-folders-list" onDragEnd={onStoriesDragEnd}>
        {getRows(storiesList)}
      </ReorderableBlockList>
    </Box>
  ) : null;
};
